module.exports = __webpack_public_path__ + "static/media/acai_bowl.34adc2c2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/GetDish/acai_bowl.jpg
// module id = 339
// module chunks = 0